<template>
  <div class="status-com">
		<div>
			<div class="status-icon-container" :style="iconComStyle">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 86 86" fill="none">
					<circle cx="43" cy="43" r="38.9097" :stroke="mainColor" stroke-dasharray="120 30">
						<animateTransform
							attributeName="transform"
							begin="0s"
							dur="2s"
							type="rotate"
							from="0 43 43"
							to="360 43 43"
							repeatCount="indefinite"
						/>
					</circle>
					<circle cx="43" cy="43" r="42" :stroke="mainColor" stroke-width="1.5"/>
					<circle cx="43" cy="43" r="24.8629" :stroke="mainColor" stroke-width="0.5"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M6.45474 40.0502C7.88695 22.0611 22.3042 7.73035 40.3311 6.43345V15.737C27.4277 16.9847 17.1432 27.1851 15.7657 40.0502H6.45474ZM6.47819 46.2308C8.03731 64.0879 22.3981 78.2764 40.3311 79.5665V70.2629C27.5218 69.0243 17.2933 58.9631 15.7972 46.2308H6.47819ZM70.2027 46.2308C68.7396 58.6825 58.9247 68.5797 46.5117 70.1683V79.4962C64.0501 77.8295 77.9872 63.8073 79.5218 46.2308H70.2027ZM79.5452 40.0502C78.1354 22.3423 64.1434 8.17934 46.5117 6.5038V15.8317C59.0179 17.4322 68.8869 27.4665 70.2343 40.0502H79.5452Z" :fill="mainColor" fill-opacity="0.3">
					</path>
					<path d="M40.3311 6.43344H40.7061V6.03049L40.3042 6.05941L40.3311 6.43344ZM6.45471 40.0502L6.08089 40.0204L6.04867 40.4252H6.45471V40.0502ZM40.3311 15.737L40.3672 16.1103L40.7061 16.0775V15.737H40.3311ZM15.7656 40.0502V40.4252H16.1026L16.1385 40.0901L15.7656 40.0502ZM6.47816 46.2308V45.8558H6.06899L6.10458 46.2634L6.47816 46.2308ZM40.3311 79.5665L40.3042 79.9406L40.7061 79.9695V79.5665H40.3311ZM40.3311 70.2629H40.7061V69.9224L40.3672 69.8896L40.3311 70.2629ZM15.7972 46.2308L16.1696 46.187L16.1307 45.8558H15.7972V46.2308ZM46.5117 70.1682L46.4641 69.7963L46.1367 69.8382V70.1682H46.5117ZM70.2027 46.2308V45.8558H69.8692L69.8303 46.187L70.2027 46.2308ZM46.5117 79.4962H46.1367V79.9085L46.5472 79.8695L46.5117 79.4962ZM79.5218 46.2308L79.8954 46.2634L79.9309 45.8558H79.5218V46.2308ZM46.5117 6.50379L46.5472 6.13047L46.1367 6.09146V6.50379H46.5117ZM79.5452 40.0502V40.4252H79.9513L79.919 40.0204L79.5452 40.0502ZM46.5117 15.8317H46.1367V16.1617L46.4641 16.2036L46.5117 15.8317ZM70.2343 40.0502L69.8614 40.0901L69.8973 40.4252H70.2343V40.0502ZM40.3042 6.05941C22.0923 7.36962 7.5278 21.8467 6.08089 40.0204L6.82853 40.0799C8.24604 22.2754 22.516 8.09107 40.358 6.80747L40.3042 6.05941ZM40.7061 15.737V6.43344H39.9561V15.737H40.7061ZM16.1385 40.0901C17.4971 27.4018 27.6411 17.3408 40.3672 16.1103L40.295 15.3638C27.2142 16.6286 16.7892 26.9684 15.3928 40.0102L16.1385 40.0901ZM15.7656 39.6752H6.45471V40.4252H15.7656V39.6752ZM6.10458 46.2634C7.6797 64.3038 22.1872 78.6372 40.3042 79.9406L40.358 79.1925C22.609 77.9156 8.39486 63.8721 6.85174 46.1981L6.10458 46.2634ZM40.7061 79.5665V70.2629H39.9561V79.5665H40.7061ZM40.3672 69.8896C27.7339 68.6681 17.6451 58.7444 16.1696 46.187L15.4247 46.2745C16.9414 59.1818 27.3096 69.3805 40.295 70.6362L40.3672 69.8896ZM6.47816 46.6058H15.7972V45.8558H6.47816V46.6058ZM46.5593 70.5402C59.1429 68.9298 69.0919 58.8975 70.5752 46.2745L69.8303 46.187C68.3873 58.4676 58.7064 68.2295 46.4641 69.7963L46.5593 70.5402ZM46.8867 79.4962V70.1682H46.1367V79.4962H46.8867ZM79.1482 46.1981C77.6293 63.5943 63.8346 77.4733 46.4762 79.1229L46.5472 79.8695C64.2655 78.1857 78.345 64.0203 79.8954 46.2634L79.1482 46.1981ZM70.2027 46.6058H79.5218V45.8558H70.2027V46.6058ZM46.4762 6.87711C63.927 8.53546 77.7761 22.5538 79.1714 40.0799L79.919 40.0204C78.4948 22.1308 64.3598 7.82321 46.5472 6.13047L46.4762 6.87711ZM46.8867 15.8317V6.50379H46.1367V15.8317H46.8867ZM70.6071 40.0102C69.2412 27.2536 59.2373 17.0822 46.5593 15.4597L46.4641 16.2036C58.7984 17.7822 68.5326 27.6794 69.8614 40.0901L70.6071 40.0102ZM79.5452 39.6752H70.2343V40.4252H79.5452V39.6752Z" :fill="mainColor">
					</path>
					<path d="M51.5135 54.35C49.1421 56.1316 46.1943 57.1873 43 57.1873C35.8805 57.1873 29.9859 51.9432 28.9681 45.107H20.7636C21.8254 56.4539 31.3756 65.3345 43 65.3345C48.0179 65.3345 52.6493 63.6796 56.3783 60.886L51.5135 54.35Z" :fill="`url(#paint2_radial_0_1${defsKey})`">
						<animateTransform
							attributeName="transform"
							begin="0s"
							dur="2s"
							type="rotate"
							from="0 43 43"
							to="360 43 43"
							repeatCount="indefinite"
						/>
					</path>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M69.3531 35.5048C67.214 27.9688 61.9295 21.7558 55.0086 18.3745L42.2976 42.5786L69.3531 35.5048Z" :fill="mainColor">
						<animateTransform
							attributeName="transform"
							begin="0s"
							dur="2s"
							type="rotate"
							from="0 43 43"
							to="-360 43 43"
							repeatCount="indefinite"
						/>
					</path>
					<defs>
						<linearGradient id="paint0_linear_0_1" x1="-226" y1="-22.6487" x2="315.484" y2="-22.6487" gradientUnits="userSpaceOnUse">
							<stop stop-color="#002AA5" stop-opacity="0"/>
							<stop offset="0.260417" stop-color="#002AA5"/>
							<stop offset="0.71875" stop-color="#002AA5"/>
							<stop offset="1" stop-color="#002AA5" stop-opacity="0"/>
						</linearGradient>
						<radialGradient :id="`paint2_radial_0_1${defsKey}`" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(24.7391 45.107) rotate(25.719) scale(29.7796 52.4333)">
							<stop :stop-color="mainColor"/>
							<stop offset="1" :stop-color="mainColor" stop-opacity="0"/>
						</radialGradient>
					</defs>
				</svg>
			</div>
			<img style="margin-top: -5px" src="./statusCom.png" width="100%" height="auto" />
		</div>
    <div class="text-container" :style="style">
      <div v-if="showNum" class="status-num" :style="numStyle">
        {{ field3 }}
      </div>
      <div v-if="showTitle" class="status-title">
        {{ title }}
      </div>
    </div>
  </div>
</template>
<script>
import Minin from './mixin'
import { dataInterface } from '@/apis/data/index'
import eventBus from '@/plugins/eventBus';
import { getComponentById, initParams } from '@/utils/tools';
export default {
  name: 'StatusCom',
  mixins: [Minin],
  data() {
    return {
      sourceData: {
				field_1: 0,
				field_2: 0,
				field_3: 0,
				field_4: 0
			},
			defsKey: this.getKey()
    }
  },
  computed: {
    // 数据仓库配置
		database() {
			return this.element && this.element.database;
		},
		field3() {
			return this.sourceData.field_3 || 0
		},
    iconComStyle() {
      return {
        width: '100%',
        height: `${this.element.style.width - 30}px`
      }
    },
    title() {
      return this.statusConfig.title || '';
    },
    showNum() {
      return this.statusConfig.showNum;
    },
    showTitle() {
      return this.statusConfig.showTitle;
    },
    numStyle() {
      return {
        color: this.statusConfig.numColor
      }
    },
    mainColor() {
      const field1 = this.sourceData.field_1;
			const field2 = this.sourceData.field_2;
			const field3 = this.sourceData.field_3;
			const field4 = this.sourceData.field_4;
			// 有重大问题未处理
			if (field1 > 0) {
				return '#C82323';
			} else if (field2 > 0) {
				return '#FFB657';
			} else if (field4 === 0) {
				return '#ffffff';
			} else if (field3 === 0) {
				return '#10E3AC';
			} else {
				return '#000000';
			}
    },
    secondColor() {
      return `${this.mainColor}33`;
    },
    thirdColor() {
      return `${this.mainColor}55`;
    },
    fourthColor() {
      return `${this.mainColor}99`;
    },
    style() {
      return {
        fontSize: this.fontSize
      }
    }
  },
  created() {
		if (this.database && !this.hasComponentParam()) {
			const { search = [], param = {}, canPost } = initParams(this.element?.database?.paramsConfig || [], this.isGroup, this.componentData, this.groupComponents);
			if (!canPost) return;
			this.getList(this.database, search, param);
		}
		this.metadata = this.element.metadata || [];
	},
  mounted() {
		// 监听请求
		// 配置关联参数的容器才需要监听
		const databaseTrigger = {
			[this.element.id]: (data) => {
				if (data.parentId && data.parentId !== this.element.id) return false;
				// 配置时候触发请求
				if (data.componentId === this.element.id && data.isInit) {
					const { search = [], param = {}, canPost } = initParams(this.element?.database?.paramsConfig || [], this.isGroup, this.componentData, this.groupComponents);
					if (!canPost) return;
					this.getList(this.element.database, search, param);
					return;
				}
				// 点击操作时候不更新数据
				if (data.noUpdate) return;
				const { paramsConfig } = this.element.database;
				if (!paramsConfig || !paramsConfig.length) return;
				// 以下步骤是为了避免有多个来源的search需要进行differ 避免检索结果错误情况
				let { search = [], param = {}, canPost } = initParams(this.element?.database?.paramsConfig || [], this.isGroup, this.componentData, this.groupComponents);
				// console.log("以下步骤是为了避免有多个来源的search需要进行differ-------", canPost, search, param);
				if (!canPost) return;
				let isTarget = false;
				paramsConfig.forEach((ele) => {
					if (ele.componentId === data.componentId) {
						isTarget = true;
					}
				});
				if (!isTarget && !data.isUpdate) return;
				this.param = param;
				this.getList(this.element.database, search, param);
			}
		}
		eventBus.$on('databaseTrigger', databaseTrigger[this.element.id]);
	},
  methods: {
		getKey() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
          d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;   // d是随机种子
          d = Math.floor(d / 16);
          return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      })
      return uuid;
    },
    /**
		 * @desc: 获取渲染列表
		 * @param {Object} database 数据配置对象
		 * @param {Array} search 搜索
		 */
		getList(database, search = [], params = {}) {
			this.search = Array.isArray(search) ? search : [];
			this.sourceData = {};
			if (!this.validDatabase(database)) return;
			this.loading = true;
			const paramsObj = {
				...params
			};
			// console.log('获取渲染列表______表格容器', params, paramsObj);
			// 配置
			let __method_name__ = 'dataList';
			const mapping = database.mapping;
			let configObj = null;
			if (mapping === 'object') {
				configObj = {
					__method_name__,
					object_uuid: database.objectData.uuid,
					view_uuid: database.viewData.uuid,
					transcode: 0,
					...paramsObj,
					search
				};
			} else if (mapping === 'relation') {
				__method_name__ = 'relationList';
				configObj = {
					__method_name__: 'relationList',
					object_uuid: database.objectData.uuid,
					relationship_uuid: database.relationData.uuid,
					...paramsObj,
					search
				};
			}
			// 获取表格数据
			dataInterface(configObj)
				.then((res) => {
					if (res && res.status === 200) {
            // 验证数据格式
						if (res.data && res.data.data && Array.isArray(res.data.data.data) && res.data.data.data.length) {
							const data = res.data.data.data[0];
							const flag = ['field_1', 'field_2', 'field_3', 'field_4'].every(el => el in data);
							if (flag) {
								this.sourceData = data;
							} else {
								this.$message.error('数据格式存在问题！')
							}
						}
          }
				})
				.catch((err) => {
					console.log(err);
				});
		},
    /**
		 * @desc: 验证
		 * @param {Object} database 数据仓库的绑定
		 */
		validDatabase(database) {
			if (!database || typeof database !== 'object') return false;
			if (!database.objectData) return false;
			if (!database.viewData && !database.relationData) return false;
			return true;
		},
    /**
		 * @desc: 判断是否存在依赖其他组件的取值
		 */
		hasComponentParam() {
			if (!this.database.paramsConfig || !this.database.paramsConfig.length) {
				return false;
			}
			for (let i = 0; i < this.database.paramsConfig.length; i++) {
				const { componentId = '', key = '', sourceType = '' } = this.database.paramsConfig[i];
				if ((key !== 'search' || !componentId.includes('CommonForm')) && sourceType !== 'url') {
					// componentId.includes('CommonTableContainer')兼容跨页请求的动态判定
					// 补充不同架构问题
					if (!componentId.includes('CommonTableContainer') && this.paramsSameArchi(componentId)) {
						return true;
					}
				}
			}
			return false;
		},
    /**
		 * @desc: 判断依赖的参数是否在当前架构下启用(@凌志华树形图架构限制)
		 * @param {String} componentId
		 * @return {Boolean}
		 */
		paramsSameArchi(componentId) {
			const comp = getComponentById(this.componentData, componentId);
			if (!comp) return false;
			const targetArchi = this.$GetTargetArchi('archiType');
			if (comp && comp.archiLimit && comp.archiLimit.length && comp.archiLimit.includes(targetArchi)) {
				return true;
			}
			return false;
		}
  }
}
</script>
<style lang="less" scoped>
  .status-com{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    .status-icon-container{
      padding: 10px 20px 0 20px;
      box-sizing: border-box;
    }
    .text-container{
			margin-top: -5px;
      width: 100%;
      .status-num{
        text-align: center;
        font-weight: 700;
      }
      .status-title{
        margin: 10px 0;
        text-align: center;
        font-weight: 700;
      }
    }
  }
</style>